// API URL utility - automatically uses the correct backend based on current domain
// This eliminates the need to rebuild when deploying to different environments

const getApiUrl = () => {
  // In production, use relative URL (same domain)
  // This works because the backend and frontend are served from the same domain
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Production domain - use relative URL
    if (hostname === 'energyperformancedirect.co.uk' || hostname === 'www.energyperformancedirect.co.uk') {
      return '/api';
    }
    
    // Preview/development - use environment variable or relative URL
    if (process.env.REACT_APP_BACKEND_URL) {
      return `${process.env.REACT_APP_BACKEND_URL}/api`;
    }
  }
  
  // Fallback to relative URL
  return '/api';
};

export const API = getApiUrl();
export const BACKEND_URL = typeof window !== 'undefined' ? window.location.origin : (process.env.REACT_APP_BACKEND_URL || '');
